<div class="bf">
  <div class="bf-fej">
    <h4>Belépés a rendszerbe</h4>
    <ion-button size="small" fill="clear" (click)="betolt()" [disabled]="toltodik || fut" title="Állapot frissítése">
      <ion-icon slot="icon-only" name="refresh"></ion-icon>
    </ion-button>
  </div>

  <div class="bf-allapot" *ngIf="toltodik">
    <ion-spinner name="dots"></ion-spinner> Belépési fiók keresése…
  </div>

  <div class="bf-allapot hiba" *ngIf="!toltodik && hiba">
    <ion-icon name="alert-circle-outline"></ion-icon> {{ hiba }}
  </div>

  <ng-container *ngIf="!toltodik && !hiba && allapot">
    <!-- VAN-E FIÓK. Ez az a kérdés, amire a szerkesztőben eddig sehol nem volt válasz:
         a törzsadat rendben lehetett, a felhasználó mégsem tudott belépni. -->
    <div class="bf-sor" *ngIf="vanFiok">
      <ion-chip color="success" outline="true">
        <ion-icon name="checkmark-circle"></ion-icon>
        <ion-label>Van belépési fiókja</ion-label>
      </ion-chip>
      <span class="bf-nev">{{ allapot.kc_username }}</span>
      <ion-chip color="danger" outline="true" *ngIf="allapot.engedelyezve === false">
        <ion-label>letiltva</ion-label>
      </ion-chip>
    </div>

    <div class="bf-sor" *ngIf="!vanFiok">
      <ion-chip color="warning" outline="true">
        <ion-icon name="alert-circle"></ion-icon>
        <ion-label>Nincs belépési fiókja</ion-label>
      </ion-chip>
      <span class="halvany">Enélkül a törzsadat rendben lehet, de belépni nem tud.</span>
    </div>

    <!-- A fiók MÁS néven van: működik, de a felülírás azt a fiókot érinti. -->
    <ion-note color="warning" class="bf-megj" *ngIf="masNeven">
      A fiókot az <b>e-mail címe</b> alapján találtuk meg, a felhasználóneve
      <b>{{ allapot.kc_username }}</b> — nem a törzsadatbeli azonosító. Belépni így is tud;
      a felülírás ezt a fiókot érinti.
    </ion-note>

    <ion-note color="medium" class="bf-megj" *ngIf="!allapot.email">
      Nincs e-mail cím a törzsadatban, ezért a belépési adatokat <b>nem tudjuk kiküldeni</b> —
      a jelszót itt kell leolvasni és átadni.
    </ion-note>

    <div class="bf-gombok">
      <ion-button size="small" color="primary" *ngIf="!vanFiok"
                  [disabled]="fut" (click)="fiokot(false, false)">
        <ion-icon slot="start" name="person-add"></ion-icon> Fiók létrehozása
      </ion-button>
      <ion-button size="small" color="primary" *ngIf="!vanFiok"
                  [disabled]="fut || !allapot.email" (click)="fiokot(false, true)">
        <ion-icon slot="start" name="mail"></ion-icon> Létrehozás és kiküldés e-mailben
      </ion-button>

      <ion-button size="small" color="warning" *ngIf="vanFiok"
                  [disabled]="fut" (click)="fiokot(false, false)">
        <ion-icon slot="start" name="key"></ion-icon> Új jelszó (felülírás)
      </ion-button>
      <ion-button size="small" fill="outline" *ngIf="vanFiok"
                  [disabled]="fut || !allapot.email" (click)="kikuldes()">
        <ion-icon slot="start" name="mail"></ion-icon> Belépési adatok kiküldése
      </ion-button>
    </div>

    <!--  A KIADOTT ADATOK. Csak most látszanak: a jelszót nem tároljuk, a szerkesztő
          bezárása után már csak új jelszót lehet küldeni. -->
    <div class="bf-adat" *ngIf="frissAdat">
      <div class="bf-adat-cim">
        <ion-icon name="lock-open"></ion-icon> Belépési adatok — most jegyezd fel vagy küldd ki
      </div>
      <div class="bf-adat-sor">
        <span class="cimke">Felhasználónév</span>
        <code>{{ frissAdat.username }}</code>
        <ion-button size="small" fill="clear" (click)="masol(frissAdat.username)">
          <ion-icon slot="icon-only" name="copy-outline"></ion-icon>
        </ion-button>
      </div>
      <div class="bf-adat-sor">
        <span class="cimke">Ideiglenes jelszó</span>
        <code>{{ frissAdat.jelszo }}</code>
        <ion-button size="small" fill="clear" (click)="masol(frissAdat.jelszo)">
          <ion-icon slot="icon-only" name="copy-outline"></ion-icon>
        </ion-button>
      </div>
      <ion-note color="medium" class="bf-megj">
        <span *ngIf="frissAdat.jelszo_forras === 'szuletes'">
          A jelszó a <b>születési dátum</b> (ÉÉÉÉHHNN) — ezt a felhasználó fejből tudja.
        </span>
        <span *ngIf="frissAdat.jelszo_forras !== 'szuletes'">
          Nincs rögzített születési dátum, ezért <b>véletlen jelszó</b> készült — ezt át kell adni.
        </span>
        Az első belépéskor a rendszer új jelszót kér.
      </ion-note>
    </div>
  </ng-container>
</div>
